import { FC } from "react";
import { FormattedNumber } from "react-intl";
import InstantBookFilled from "@/icons/__generated__/InstantBookFilled/InstantBookFilled20"; // Ensure this is the correct import path
interface PriceBoxProps {
  price: number;
  displayFrom?: boolean;
  displayFromText?: string;
  fromText?: string;
  showInstaBook?: boolean;
  currency?: string;
  pricePerHourText?: string;
}

export const PriceBox: FC<PriceBoxProps> = ({
  price = 0,
  displayFrom = true,
  displayFromText = "from",
  showInstaBook = true,
  pricePerHourText = "/hr",
  currency = "USD",
}) => {
  return (
    <div className="tw-bg-base-black tw-px-8 tw-py-4 tw-rounded-4 tw-flex tw-items-center">
      {showInstaBook && (
        <div className="tw-text-base-white tw-mr-4 tw-h-20">
          <InstantBookFilled />
        </div>
      )}
      {displayFrom && (
        <span className="tw-text-base-white tw-body-1">
          {displayFromText}&nbsp;
        </span>
      )}
      <span className="tw-text-base-white tw-headline-1-m">
        <FormattedNumber
          value={price}
          style="currency"
          currency={currency}
          minimumFractionDigits={0}
          maximumFractionDigits={0}
        />
      </span>
      <span className="tw-text-base-white tw-headline-1-m">
        {pricePerHourText}
      </span>
    </div>
  );
};
